import type {QueryFunctionContext} from 'react-query'
import {AxiosError} from 'axios'
import http from '@/utils/axios'
import type {
	Params,
	TBreadcrumbs,
} from '@/_new-code/services/breadcrumbs/models'

interface ErrorResponse {
	error: string
}

export const useFetchBreadcrumbs = async (
	context: QueryFunctionContext
): Promise<TBreadcrumbs | ErrorResponse | null> => {
	try {
		const {pageId, locale, pageUrl} = context.queryKey[1] as Params
		const isTaxonomyTermPage = pageUrl.includes('taxonomy/term')
		if (isTaxonomyTermPage) {
			// Return null to prevent breadcrumbs from being displayed for taxonomy term pages since they does not exist in kontent.ai
			return null
		}
		const endpoint = `/api/breadcrumbs?pageId=${pageId}&locale=${locale}&pageUrl=${pageUrl}`
		const {data} = await http<{
			success: boolean
			data: TBreadcrumbs
			error?: string
		}>(endpoint)
		return data.data
	} catch (error: unknown) {
		return {
			error:
				error instanceof AxiosError
					? (error.response?.data as {error?: string}).error ??
						'Failed to fetch breadcrumbs'
					: 'Failed to fetch breadcrumbs',
		}
	}
}
